module.exports = __webpack_public_path__ + "static/img/14.7509297.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/sp/14.png
// module id = GWC8
// module chunks = 0